/**
 * FAQ accordion — uses native <details> + sync class for icon styling.
 *
 * The .is-open class keeps the +/× icon transform in sync with the open state.
 */
export function initFaq() {
  document.querySelectorAll('.faq-item').forEach((el) => {
    el.addEventListener('toggle', () => {
      el.classList.toggle('is-open', el.open);
    });
  });
}
